import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Close14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M7.00006 5.93934L3.53039 2.46967L2.46973 3.53033L5.9394 7L2.46973 10.4697L3.53039 11.5303L7.00006 8.06066L10.4697 11.5303L11.5304 10.4697L8.06072 7L11.5304 3.53033L10.4697 2.46967L7.00006 5.93934Z'
      fill='currentColor'
    />
  </Svg>
);

Close14.displayName = 'Close14';
export default Close14;
